export class Model {
  id: string
  _destroy: boolean = false;

  constructor(obj = {}) {
    for (let key in obj) {
      let value = obj[key]
      if (value != null && key !== '_destroy') {
        let attribute = key.camelize(false)
        this[attribute] = value
      }
    }
  }

  clone(): any {
    let obj = JSON.parse(JSON.stringify(this))
    return new (<any>this).constructor(obj)
  }
}
